import { INPUT_TYPE, OTHER } from "globalConstants";
import { ICommonFixture } from "types";

const fixture: ICommonFixture[] = [
    {
        name: "income",
        label: "Income",
        inputType: INPUT_TYPE.PRICE,
        defaultValue: "",
        subtitle: "Last 12 Months",
    },
    {
        name: "activity",
        label: "Activity Type",
        inputType: INPUT_TYPE.SELECT,
        options: ["agriculture_farming", OTHER],
        defaultValue: "agriculture_farming",
        editable: true,
    },
    {
        name: "otherActivity",
        label: "Other",
        inputType: INPUT_TYPE.TEXT,
        defaultValue: "",
        subtitle: "Specify Activity",
    },
    {
        name: "asset",
        label: "Asset",
        inputType: INPUT_TYPE.SELECT,
        options: ["yes", "no"],
        subtitle: "Own Underlying Asset ?",
        editable: true,
    },
];

export default fixture;
